module.exports = __webpack_public_path__ + "img/bird-2.166f38f4.png";